export const GET_ONBOARDING_MODALS = 'app/Main/GET_ONBOARDING_MODALS';
export const GET_ONBOARDING_MODALS_SUCCESS =
  'app/Main/GET_ONBOARDING_MODALS_SUCCESS';
export const GET_ONBOARDING_MODALS_FAIL = 'app/Main/GET_ONBOARDING_MODALS_FAIL';
